export const startOfMonth = (d: Date) => new Date(d.getFullYear(), d.getMonth(), 1);
export const endOfMonth = (d: Date) => new Date(d.getFullYear(), d.getMonth() + 1, 0);
export const format = (d: Date, pattern: string) => {
  const mes = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  return pattern === 'yyyy-MM' ? mes : `${mes}-${String(d.getDate()).padStart(2, '0')}`;
};
